import { render, staticRenderFns } from "./MoveProjectModal.vue?vue&type=template&id=76c74ede"
import script from "./MoveProjectModal.vue?vue&type=script&lang=js"
export * from "./MoveProjectModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports